import React, { useState } from 'react';
import Header from 'on_web/components/shared/Menu/Header/Header';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import StickyNavigation from 'on_web/components/shared/Common/StickyNavigation/StickyNavigation';
import PageItemContainer from 'on_web/components/shared/Common/PageItemContainer/PageItemContainer';
import { makeStyles } from '@material-ui/core/styles';
import UserProfileContext from 'on_web/context/userProfileContext';

import Question from 'on_web/components/shared/Question/Question';

import { Trans, useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  textBody: {
    '@media (max-height: 700px)': {
      maxHeight: '60vh',
      overflowY: 'scroll',
    },
    whiteSpace: '-moz-pre-wrap' /* Mozilla */,
    whiteSpace: '-hp-pre-wrap' /* HP printers */,
    whiteSpace: '-o-pre-wrap' /* Opera 7 */,
    whiteSpace: '-pre-wrap' /* Opera 4-6 */,
    whiteSpace: 'pre-wrap' /* CSS 2.1 */,
    whiteSpace: 'pre-line' /* CSS 3 (and 2.1 as well, actually) */,
  },
});

function IntroAgreement(props) {
  const context = React.useContext(UserProfileContext);
  const classes = useStyles();
  const [agreementAnswer, setAgreementAnswer] = useState(
    context ? context.user_metadata.agreement : undefined
  );

  const onClickNext = () => {
    const userMetadata = context ? context.user_metadata : null;
    if (props.onClickNext && userMetadata && agreementAnswer) {
      userMetadata.agreement = agreementAnswer;
      props.onClickNext(userMetadata);
    }
  };

  const onClickBack = () => {
    if (props.onClickBack) {
      props.onClickBack();
    }
  };

  const { t } = useTranslation();
  const questionsForAgreement = [
    {
      checked: agreementAnswer === '1',
      value: '1',
      label: t('onboarding.introSection.introAgreement.agreementTerms1'),
    },
    {
      checked: agreementAnswer === '2',
      value: '2',
      label: t('onboarding.introSection.introAgreement.agreementTerms2'),
    },
  ];

  return (
    <div>
      <Header />

      <Box mr={{ xs: 5 }} ml={{ xs: 5 }} textAlign="left">
        <PageItemContainer>
          <Box textAlign="center" mt={2} mb={2} fontSize={24}>
            <Typography color="primary" variant="h2">
              {t('onboarding.introSection.introAgreement.heading')}
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1" className={classes.textBody}>
              <Trans i18nKey="onboarding.introSection.introAgreement.agreementTextParagraph" />
            </Typography>
          </Box>
          <Question
            radioSelection={{ items: questionsForAgreement }}
            onAnswer={val => setAgreementAnswer(val)}
          />
        </PageItemContainer>
      </Box>
      <StickyNavigation
        onClickNext={() => onClickNext()}
        onClickBack={() => onClickBack()}
        nextButtonDisabled={!agreementAnswer}
      />
    </div>
  );
}

export default IntroAgreement;
